<template>
  <router-view/>
</template>

<style lang="scss">
  div {
    box-sizing: border-box;
  }
</style>
